import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'categories-category_homepage_shop_by_category-view';
/**
 * Tracks when the shop by category carousel is been viewed
 */
export function trackCategoriesCategoryHomepageShopByCategoryView(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
